import React, { useState } from "react";
import logo from "../../newProviderApp/image/playbacklogo.png";
import mic from "../images/mic.svg";
import SelectTemplatesComp from "../../notes-fhir/component/SelectTemplatesComp";
const Header = ({ setStartRecord, startRecord, setShowButton, showButton, callback }) => {
   const [showAddTemplate, setShowAddTemplate] = useState(false);
   return (
      <nav id="navbar" className={`p-2 navbar  `}>
         <div className="  nav-logo-div h-100 py-1  pl-4 ">
            <img className="h-100 pointer" src={logo} height={42} width={169} alt={"playback-logo"} />
         </div>
         <div className="flex-center">
            {!startRecord && (
               <div
                  onClick={() => {
                     setShowAddTemplate(true);
                  }}
                  className="add-template-button-epic"
               >
                  Add new templates +
               </div>
            )}
            {!startRecord && (
               <div
                  onClick={() => {
                     setStartRecord(!startRecord);
                     setShowButton(false);
                  }}
                  className={`record-mic-button-epic pointer`}
               >
                  <img src={mic} alt="record-button-epic" /> Record Note
               </div>
            )}
         </div>
         {/* {showButton && (
            <div
               onClick={() => {
                  callback();
               }}
               className={`record-mic-button-continue-epic pointer`}
            >
               Continue
            </div>
         )} */}

         {showAddTemplate && (
            <SelectTemplatesComp
               setShowAddTemplate={setShowAddTemplate}
               onModalTapped={() => setShowAddTemplate(false)}
               getNotesTemplate={() => {}}
            />
         )}
      </nav>
   );
};

export default Header;
